import {Calendar, Typography, Radio, Tooltip} from "antd";
import React, {FC, memo, useState} from "react";
import moment, {Moment} from "moment";
import {CalendarMode} from "antd/lib/calendar/generateCalendar";
import css from "./IndividualDueDay.less";

type Month = {label: string; value: number /* ; disabled?: boolean */};

type CustomCalendarProps = {
    firstCourseLessonDate: Date;
    selectedDate: Moment;
    setSelectedDate: (date: Moment) => void;
    liftSelectedMonth?: (month: number) => void;
    subHeadline?: string | React.ReactNode;
    dummy?: boolean;
    initialSelectedMonth?: number;
};

const CustomCalendar: FC<CustomCalendarProps> = ({
    firstCourseLessonDate,
    selectedDate,
    setSelectedDate,
    liftSelectedMonth,
    subHeadline,
    dummy = false,
    initialSelectedMonth,
}) => {
    const monthOfFirstCourseLessonDate = moment(firstCourseLessonDate).month();
    const availableMonths: Array<Month> = [
        {
            value: monthOfFirstCourseLessonDate - 1,
            label: dummy
                ? "Vormonat"
                : moment(firstCourseLessonDate)
                      .subtract(1, "month")
                      .format("MMMM"),
        },
        {
            value: monthOfFirstCourseLessonDate,
            label: dummy
                ? "Monat des Kursbeginns"
                : moment(firstCourseLessonDate).format("MMMM"),
        },
        {
            value: monthOfFirstCourseLessonDate + 1,
            label: dummy
                ? "Folgemonat"
                : moment(firstCourseLessonDate)
                      .add(1, "month")
                      .format("MMMM"),
        },
    ];
    const monthOfSelectedDate = moment(selectedDate).month();
    const [selectedMonth, setSelectedMonth] = useState<number>(
        initialSelectedMonth ?? monthOfSelectedDate,
    );

    // console.log("==> monthOfSelectedDate", monthOfSelectedDate);
    // console.log("==> selectedMonth", selectedMonth);
    // console.log("==> initialSelectedMonth", initialSelectedMonth);

    React.useEffect(() => {
        if (initialSelectedMonth !== undefined)
            setSelectedMonth(initialSelectedMonth);
    }, [initialSelectedMonth]);

    const onPanelChange = (value: Moment, mode: CalendarMode) => {
        const selectedMonth = value.month();

        setSelectedMonth(selectedMonth);
        setSelectedDate(value);
        if (liftSelectedMonth) liftSelectedMonth(selectedMonth);
    };

    // const validRange:[Moment, Moment] = [moment(firstCourseLessonDate), moment().endOf("year")];
    const validRange: [Moment, Moment] = [
        moment(firstCourseLessonDate)
            .subtract(1, "month")
            .startOf("month"),
        moment(firstCourseLessonDate)
            .add(1, "month")
            .endOf("month"),
    ];

    return (
        <Calendar
            className={css.siteCalendarCard}
            // mode="month" // DEBUGGING
            fullscreen={false}
            value={selectedDate} // DEBUGGING
            // value={moment.utc(selectedDate).clone()} // DEBUGGING
            validRange={validRange}
            // dateFullCellRender
            dateFullCellRender={(date) => {
                if (
                    date.format("DD.MM.YYYY") ===
                        moment(firstCourseLessonDate).format("DD.MM.YYYY") &&
                    date.format("DD.MM.YYYY") ===
                        moment(selectedDate).format("DD.MM.YYYY")
                ) {
                    return (
                        <Tooltip title="Zahltermin & Kursbeginn">
                            <div className={css.calendarSameDate}>
                                {date.date()}
                            </div>
                        </Tooltip>
                    );
                } else if (
                    date.format("DD.MM.YYYY") ===
                    moment(firstCourseLessonDate).format("DD.MM.YYYY")
                ) {
                    return (
                        <Tooltip title="Erste Kurseinheit">
                            <div className={css.calendarFirstCourseLesson}>
                                {date.date()}
                            </div>
                        </Tooltip>
                    );
                } else if (
                    date.format("DD.MM.YYYY") ===
                    moment(selectedDate).format("DD.MM.YYYY")
                ) {
                    return (
                        <Tooltip title="Zahltermin">
                            <div className={css.calendarSelectedDate}>
                                {date.date()}
                            </div>
                        </Tooltip>
                    );
                }

                return date.date();
            }}
            onPanelChange={onPanelChange}
            onChange={(date) => {
                setSelectedDate(date);
            }}
            headerRender={({value, type, onChange, onTypeChange}) => {
                return (
                    <div style={{padding: 8}}>
                        <Typography.Title level={4}>
                            {"Zahltermin wählen"}
                        </Typography.Title>
                        <div
                            style={{
                                marginTop: -7,
                                marginBottom: 7,
                                fontWeight: 500,
                            }}
                        >
                            {subHeadline}
                        </div>
                        <Radio.Group
                            className={css.monthSelector}
                            optionType="button"
                            buttonStyle="solid"
                            // value={selectedMonth}
                            value={
                                monthOfFirstCourseLessonDate === 11 &&
                                selectedMonth === 0
                                    ? 12
                                    : selectedMonth
                            }
                            options={availableMonths}
                            onChange={(e) => {
                                // DEBUGGING ----------------------------------------------------
                                const firstDayOfSelectedMonth = moment(
                                    moment
                                        .utc(firstCourseLessonDate)
                                        .set("month", e.target.value)
                                        .clone(),
                                ).startOf("month");

                                onPanelChange(firstDayOfSelectedMonth, "month");
                            }}
                            // onChange={(e) => {
                            //     const firstDayOfSelectedMonth = moment(
                            //         moment(firstCourseLessonDate).set(
                            //             "month",
                            //             e.target.value,
                            //         ),
                            //     ).startOf("month");

                            //     onPanelChange(firstDayOfSelectedMonth, "month");
                            // }}
                        />
                    </div>
                );
            }}
        />
    );
};

export default memo(CustomCalendar);
